import moment from 'moment-timezone';
import DateHelper from '@/core/shared/helpers/DateHelper';

export default function useActionStartTime (editBooking, startTime, bookingStationTimes, editBookingStationTime) {
  function shiftEndTime (startTime) {
    bookingStationTimes.value.forEach(bookingStationTime => {
      editBookingStationTime(
        bookingStationTime._id,
        'endTime',
        moment(startTime.value).add(bookingStationTime.tier.length, 'minutes').format(),
      );
    });
  }

  function setStartingTime (time) {
    editBooking('_startNow', false);
    let newStartTime;

    if (moment.isMoment(time)) {
      newStartTime = time.format();
    } else if (DateHelper.isISO8601String(time)) {
      newStartTime = moment(time).format();
    }

    shiftEndTime(newStartTime);

    editBooking('startTime', newStartTime);
  }

  function setStartingTimeNow () {
    editBooking('_startNow', true);
    shiftEndTime(startTime.value);
  }

  return {
    setStartingTime,
    setStartingTimeNow,
  };
}
